module.exports = __webpack_public_path__ + "img/15.cd1b4179.jpg";